/* Ruckstuhl V8 RC44 – locale bridge for legacy configurator UI
   Chrome stability: runtime translation must be idempotent. */
(function(){
  'use strict';

  function data(){
    var el=document.getElementById('rk-v8-i18n-data');
    if(!el)return {strings:{},exact:{}};
    try{return JSON.parse(el.textContent||'{}')}catch(e){return {strings:{},exact:{}}}
  }

  var dict=data();

  function format(value,vars){
    var out=String(value==null?'':value);
    Object.keys(vars||{}).forEach(function(k){
      out=out.replace(new RegExp('\\{'+k+'\\}','g'),String(vars[k]));
    });
    return out;
  }

  function t(key,fallback,vars){
    return format((dict.strings&&dict.strings[key])||fallback||key,vars||{});
  }
  window.RKV8T=t;

  function translateText(text){
    var trim=String(text||'').trim();
    if(!trim)return null;
    if(dict.exact&&Object.prototype.hasOwnProperty.call(dict.exact,trim))return dict.exact[trim];

    var m=trim.match(/^(\d+) Muster ausgewählt$/);
    if(m)return t('samples_selected_count',trim,{count:m[1]});
    m=trim.match(/^Zusatzteppich\s+(\d+)$/);
    if(m)return t('additional_rug',trim,{count:m[1]});
    m=trim.match(/^Passend zu\s+(.+)$/);
    if(m)return t('matching_to',trim,{value:m[1]});
    m=trim.match(/^(Länge|Breite|Tiefe|Durchmesser)\s+(.+)$/);
    if(m){
      var measureKeys={Länge:'length',Breite:'width',Tiefe:'ui_depth',Durchmesser:'diameter'};
      return t(measureKeys[m[1]],m[1])+' '+m[2];
    }
    m=trim.match(/^Ausgewählt:\s*(.+)$/);
    if(m)return t('ui_selected_prefix','Ausgewählt:')+' '+m[1];
    m=trim.match(/^Rollenbreite:\s*(.+)$/);
    if(m)return t('ui_roll_width','Rollenbreite')+': '+m[1];
    m=trim.match(/^Rollenlänge:\s*(.+)$/);
    if(m)return t('ui_roll_length','Rollenlänge')+': '+m[1];
    m=trim.match(/^(\d+(?:[.,]\d+)?)\s*km entfernt$/);
    if(m)return t('ui_distance_away',trim,{distance:m[1]});
    return null;
  }

  function translatedNodeValue(node){
    var current=String(node&&node.nodeValue||'');
    var repl=translateText(current);
    if(repl===null)return null;
    var lead=(current.match(/^\s*/)||[''])[0];
    var trail=(current.match(/\s*$/)||[''])[0];
    return lead+repl+trail;
  }

  function walk(root){
    if(!root)return;

    /* Textknoten nur dann schreiben, wenn sich der Wert tatsächlich ändert.
       In Chrome erzeugt auch eine erneute Zuweisung desselben nodeValue eine
       MutationObserver-Runde. Das führte beim Öffnen des Konfigurators zu einer
       selbstverstärkenden Endlosschleife. */
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{
      acceptNode:function(n){
        var p=n.parentElement;
        if(!p||/^(SCRIPT|STYLE|TEXTAREA)$/i.test(p.tagName)||p.closest('[data-rk-no-runtime-translate]'))return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(function(n){
      var next=translatedNodeValue(n);
      if(next!==null&&n.nodeValue!==next)n.nodeValue=next;
    });

    if(root.querySelectorAll){
      root.querySelectorAll('[aria-label],[placeholder],[title],[alt]').forEach(function(el){
        ['aria-label','placeholder','title','alt'].forEach(function(attr){
          if(!el.hasAttribute(attr))return;
          var current=el.getAttribute(attr);
          var repl=translateText(current);
          if(repl!==null&&current!==repl)el.setAttribute(attr,repl);
        });
      });
      root.querySelectorAll('input[type=submit][value],input[type=button][value],input[type=reset][value]').forEach(function(el){
        var current=el.value;
        var repl=translateText(current);
        if(repl!==null&&current!==repl)el.value=repl;
      });
    }
  }

  var nativeAlert=window.alert&&window.alert.bind(window),
      nativeConfirm=window.confirm&&window.confirm.bind(window),
      nativePrompt=window.prompt&&window.prompt.bind(window);
  if(nativeAlert)window.alert=function(message){var translated=translateText(message);return nativeAlert(translated===null?message:translated);};
  if(nativeConfirm)window.confirm=function(message){var translated=translateText(message);return nativeConfirm(translated===null?message:translated);};
  if(nativePrompt)window.prompt=function(message,defaultValue){var translated=translateText(message);return nativePrompt(translated===null?message:translated,defaultValue);};

  function init(){
    var lang=String(document.documentElement.lang||'de').toLowerCase();

    /* Die Legacy-Markups sind deutsch. Auf DE-Seiten ist deshalb keinerlei
       Runtime-DOM-Übersetzung nötig. RKV8T bleibt oben trotzdem verfügbar. */
    if(lang==='de'||lang.indexOf('de-')===0)return;

    walk(document.documentElement);

    var queued=false;
    var pendingRoots=[];

    function addRoot(node){
      if(!node)return;
      var root=node.nodeType===1?node:(node.parentElement||null);
      if(!root)return;
      if(pendingRoots.indexOf(root)===-1)pendingRoots.push(root);
    }

    function flush(){
      queued=false;
      var roots=pendingRoots.slice();
      pendingRoots.length=0;
      roots.forEach(walk);
    }

    var obs=new MutationObserver(function(records){
      records.forEach(function(r){
        Array.prototype.forEach.call(r.addedNodes||[],function(n){addRoot(n);});
        if(r.type==='characterData')addRoot(r.target);
        if(r.type==='attributes')addRoot(r.target);
      });
      if(!pendingRoots.length||queued)return;
      queued=true;
      requestAnimationFrame(flush);
    });

    obs.observe(document.documentElement,{
      subtree:true,
      childList:true,
      characterData:true,
      attributes:true,
      attributeFilter:['aria-label','placeholder','title','alt','value']
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
